<template>
    <div class="footer-container full-screen-container">
        <div class="main-container">
            <div class="footer-logo" v-if="footerLogo">
                <img :src="footerLogo" alt="logo">
            </div>
            <div class="footer-list flex-start">
                <div class="left-container" v-if="brandInfo.otherFooters && brandInfo.otherFooters.length">
                    <h4 class="footer-header">联系我们</h4>
                    <div class="left">
                        <div
                            class="footer-item"
                            v-for="(item, index) in brandInfo.otherFooters"
                            :key="index">
                            {{item.footerName}}：{{item.footerValue}}
                        </div>
                    </div>
                </div>
                <div class="right-container">
                    <h4 class="footer-header">版权信息</h4>
                    <div class="footer-item">
                       {{brandInfo.copyright}}
                    </div>
                    <div class="footer-item">
                        技术支持：{{brandInfo.technicalSupport}}
                    </div>
                    <div class="link-text footer-item">
                        <a target="_blank"
                            href="https://beian.miit.gov.cn">
                            {{brandInfo.recordNumber}}
                        </a>
                    </div>
                    <div class="link-text footer-item" v-if="brandInfo.publicRecord && brandInfo.publicRecord.recordCode">
                        <a v-if="brandInfo.publicRecord.recordUrl"
                            target="_blank"
                            :href="brandInfo.publicRecord.recordUrl">
                            <img class="special-img" src="@/assets/img/gateway/beian@2x.png" alt="">{{brandInfo.publicRecord.recordCode }}
                        </a>
                        <span v-else>{{brandInfo.publicRecord.recordCode }}</span>
                    </div>
                    <div class="footer-item flex-start">
                        <div class="link-text" v-if="brandInfo.userAgreementWeb">
                            <a :href="brandInfo.userAgreementWeb">用户协议</a>
                        </div>
                        <template  v-if="brandInfo.privacyClauseWeb">
                            <div class="divider-line">|</div>
                            <div class="link-text">
                                <a :href="brandInfo.privacyClauseWeb">隐私条款</a>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

// 全部备案信息
const brand = computed(() => {
    return store.state.brand && store.state.brand.publishBrand ? store.state.brand.publishBrand : {};
})

// 具体备案信息
const brandInfo = computed(() => {
    return brand.value.brandConfig ? brand.value.brandConfig : {};
})


// 底部Logo
const footerLogo = computed(() => {
    return brandInfo.value.footerLogoUrl ? brandInfo.value.footerLogoUrl : '';
})
</script>

<style lang="scss" scoped>
.footer-container {
    background: #2B2E36;
    color: #C8C7D1;
    padding: 30px 0;
    .footer-logo {
        margin-bottom: 29px;
        img {
            // width: 182px;
            width: auto;
            height: 45px;
        }
    }
    .link-text {
        a {
            color: #C8C7D1;
            &:hover {
                text-decoration: underline;
            }
        }
    }
    .footer-list {
        align-items: flex-start;
        // flex-wrap: wrap;
        // margin-top: 15px;
        .footer-item {
            width: 320px;
            line-height: 21px;
            margin-right: 30px;
            margin-bottom: 12px;
        }
        .footer-header {
            color: #ffffff;
            font-size: 14px;
            line-height: 16px;
            margin-bottom: 16px;
        }
        .divider-line {
            margin: 0 20px;
        }
        .special-img {
            width: 18px;
            height: 20px;
            margin-right: 8px;
        }
        .left-container {
            width: 800px;
            .left {
                display: flex;
                flex-wrap: wrap;
                margin-bottom: -14px;
            }
        }
        .right-container {
            width: 400px;
            margin-bottom: -14px;
            .footer-item {
                width: 400px;
                margin-right: 0;
            }
        }
    }
}
</style>
